<template>
   <div class="kinetic-toggle">
       <toggle-button v-model="state"
                      @change="toggle"
                      :disabled="disabledD"
                      :width="100"
                      :height="35"
                      :sync="true"
                      :value="state"
                      :labels="labels"/>
   </div>
</template>

<script>

import { ToggleButton } from 'vue-js-toggle-button'

export default {
  components: {
    ToggleButton
  },
  name: 'Toggle',
  props: {
    labels: {
      type: Object,
      default: function () {
        return { checked: 'Yes', unchecked: 'No' }
      }
    },
    stateP: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Alert'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'stateP',
    event: 'change'
  },
  data () {
    return {
      state: this.stateP,
      disabledD: this.disabled
    }
  },
  methods: {
    toggle (e) {
      this.$emit('toggle', e)
      this.$emit('change', e.value)
    },
    updateState (val) {
      this.state = val
      this.$emit('change', val)
    }
  },
  watch: {
    stateP: function (newVal) {
      this.updateState(newVal)
    },
    disabled: function (newVal) {
      this.disabledD = newVal
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
